export default __webpack_public_path__ + "static/media/mail.63e98a6f.png";